import { defineDefaultEnumValue } from 'src/lib/enum';

/**
 * Image aspect ratio enum.
 * @enum {string}
 * @property {IMAGE_ASPECT_RATIO} DEFAULT - default aspect ratio
 */
export const IMAGE_ASPECT_RATIO = {
  ratio1x1: '1_1',
  ratio2x3: '2_3',
  ratio3x2: '3_2',
  // TODO: remove old aspect ratios after migration to new "image" tools
  ratio16x9: '16_9',
  ratio9x16: '9_16',
  ratio4x3: '4_3',
} as const;
export type ImageAspectRatio = (typeof IMAGE_ASPECT_RATIO)[keyof typeof IMAGE_ASPECT_RATIO];
defineDefaultEnumValue(IMAGE_ASPECT_RATIO, IMAGE_ASPECT_RATIO.ratio1x1);

const IMAGE_ASPECT_RATIO_TEXT = {
  [IMAGE_ASPECT_RATIO.ratio1x1]: 'Square 1:1',
  [IMAGE_ASPECT_RATIO.ratio2x3]: 'Portrait 2:3',
  [IMAGE_ASPECT_RATIO.ratio3x2]: 'Landscape 3:2',
  [IMAGE_ASPECT_RATIO.ratio16x9]: 'Landscape 16:9',
  [IMAGE_ASPECT_RATIO.ratio9x16]: 'Portrait 9:16',
  [IMAGE_ASPECT_RATIO.ratio4x3]: 'Wide 4:3',
};
export const getAspectRatioTitle = (aspectRatio: ImageAspectRatio): string =>
  IMAGE_ASPECT_RATIO_TEXT[aspectRatio] || '';
